export default __webpack_public_path__ + "static/media/Royal Dragon Elite Boots.950559e2.jpg";